/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_Escrow_ReleaseInputs */

const en_sovereign_escrow_release = /** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart escrow release`)
};

const id_sovereign_escrow_release = /** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelepasan escrow cerdas`)
};

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const es_sovereign_escrow_release = en_sovereign_escrow_release;

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const fr_sovereign_escrow_release = en_sovereign_escrow_release;

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const de_sovereign_escrow_release = en_sovereign_escrow_release;

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const ja_sovereign_escrow_release = en_sovereign_escrow_release;

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const zh_sovereign_escrow_release = en_sovereign_escrow_release;

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const ar_sovereign_escrow_release = en_sovereign_escrow_release;

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const it_sovereign_escrow_release = en_sovereign_escrow_release;

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const ru_sovereign_escrow_release = en_sovereign_escrow_release;

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const pt_sovereign_escrow_release = en_sovereign_escrow_release;

/** @type {(inputs: Sovereign_Escrow_ReleaseInputs) => LocalizedString} */
const ko_sovereign_escrow_release = en_sovereign_escrow_release;

/**
* | output |
* | --- |
* | "Smart escrow release" |
*
* @param {Sovereign_Escrow_ReleaseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_escrow_release = /** @type {((inputs?: Sovereign_Escrow_ReleaseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_Escrow_ReleaseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_escrow_release(inputs)
	if (locale === "es") return es_sovereign_escrow_release(inputs)
	if (locale === "fr") return fr_sovereign_escrow_release(inputs)
	if (locale === "de") return de_sovereign_escrow_release(inputs)
	if (locale === "ja") return ja_sovereign_escrow_release(inputs)
	if (locale === "zh") return zh_sovereign_escrow_release(inputs)
	if (locale === "ar") return ar_sovereign_escrow_release(inputs)
	if (locale === "id") return id_sovereign_escrow_release(inputs)
	if (locale === "it") return it_sovereign_escrow_release(inputs)
	if (locale === "ru") return ru_sovereign_escrow_release(inputs)
	if (locale === "pt") return pt_sovereign_escrow_release(inputs)
	return ko_sovereign_escrow_release(inputs)
});